export default "__VITE_ASSET__B1Df1wFs__"